import HttpCalls from './service.js';

const _ContactUs = async data => {
  let {_do_call} = HttpCalls; 
  let headers = await getServiceHeaders();
  return _do_call('POST', 'contactus', headers, data); 
};

const _GetEstimated = async data => {
    let {_do_call} = HttpCalls; 
    let headers = await getServiceHeaders();
    return _do_call('POST', 'getestimate', headers, data); 
  };

  const getServiceHeaders = () =>{
    return {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }

export default { _ContactUs, _GetEstimated }
